if (!customElements.get('variants-lentillas')) {
  customElements.define(
    'variants-lentillas',
    class VariantsLentillas extends HTMLElement {
      constructor() {
        super()
        this.initProperties()
        this.setupEventListeners()
        this.renderVariantsContent()

        document.querySelector('.product__vendor--qty').innerHTML = '- ' + this.translations.price_qty
      }

      initProperties() {
        this.locale = this.dataset.locale
        this.currency = this.dataset.currency
        this.translations = {
          'sku_left': this.dataset.skuLeft,
          'sku_right': this.dataset.skuRight,
          'price_box': this.dataset.priceBox,
          'price_qty': this.dataset.priceQty,
          'price_right': this.dataset.priceRight,
          'price_discount': this.dataset.priceDiscount
        }

        this.variants = JSON.parse(this.dataset.options).variants
        this.errors = this.querySelectorAll('.lentillas_error')
        this.selectedVariants = {
          "left": null,
          "right": null
        }

        this.eyes = this.querySelectorAll('.eye-checkbox')
        this.selects = this.querySelectorAll('.lentillas-select')
        this.updateAddToCartContainer = document.querySelector('.product__addtocart')
        this.skuContainer = document.querySelector('.product__sku')
        this.priceContainer = this.querySelector('.lentillas_price')
        this.qtyContainers = this.querySelectorAll('.lentillas-qty')
        this.qtyTotal = this.querySelector('.lentillas-qty__total')
        this.qtyButtons = this.querySelectorAll('.lentillas-qty__button')
        this.qtyInputs = this.querySelectorAll('.lentillas-qty__input')
        this.form = this.querySelector('.lentillas__form')
        this.cartNotification = document.querySelector('cart-notification')
      }

      setupEventListeners() {
        this.eyes.forEach(eye => {
          eye.addEventListener('change', this.toggleEye.bind(this))
        })

        this.selects.forEach(select => {
          select.addEventListener('change', this.renderVariantsContent.bind(this))
        })

        this.qtyButtons.forEach(button => {
          button.addEventListener('click', this.updateQty.bind(this))
        })

        this.form.addEventListener('submit', this.onSubmit.bind(this))
      }

      renderVariantsContent() {
        this.updateAddToCartContainer.classList.add('loading')
        this.updateSelectedVariants()
        this.renderSku()
        this.renderPrice()
        this.updateTotalQty()
        this.updateAddToCart()
        this.updateAddToCartContainer.classList.remove('loading')
      }

      toggleEye(event) {
        const eye = event.target
        this.selects.forEach(select => {
          if (select.dataset.eye == eye.dataset.eye) {
            select.disabled = !eye.checked
          }
        })

        this.qtyContainers.forEach(qty => {
          if (qty.dataset.eye == eye.dataset.eye) {
            qty.classList.toggle('disabled', !eye.checked)
          }
        })

        this.renderVariantsContent()
      }

      updateSelectedVariants() {
        this.errors.forEach(error => {
          error.classList.add('hidden')
        })

        this.eyes.forEach(eye => {
          if (eye.checked) {
            const conditions = []
            this.selects.forEach(select => {
              if (select.dataset.eye == eye.dataset.eye) {
                conditions.push({
                  'name': select.dataset.attribute,
                  'value': select.value
                })
              }
            })

            const variant = this.variants.find(variant => {
              return conditions.every(condition => {
                return variant.atributos[condition.name] === condition.value
              })
            })

            if (!variant) {
              this.errors.forEach(error => {
                if (error.dataset.eye == eye.dataset.eye) {
                  error.classList.remove('hidden')
                }
              })
            }

            this.selectedVariants[eye.dataset.eye] = variant
          } else {
            this.selectedVariants[eye.dataset.eye] = null
          }
        })
      }

      renderSku() {
        const skus = []
        const leftSku = this.selectedVariants.left?.referencia
        const rightSku = this.selectedVariants.right?.referencia

        if (leftSku || rightSku) {
          if (leftSku) skus.push(this.translations.sku_left + leftSku)
          if (rightSku) skus.push(this.translations.sku_right + rightSku)
          this.skuContainer.innerHTML = skus.join(', ')
          this.skuContainer.classList.remove('hidden', 'visibility-hidden')
        } else {
          this.skuContainer.classList.add('hidden')
        }
      }
       //all of lentillas has to have same price
       updateAllocationPrice(priceClass, initialPriceClass, qtyTotal) {
        document.querySelectorAll(`.${priceClass}`).forEach(function(priceElement) {
          // Buscar el elemento hermano que contiene el precio inicial
          const initialPriceElement = priceElement.previousElementSibling;     
          // Si no existe el allocation_price_initial, no hacer nada
          if (!initialPriceElement) return;
          // Obtener el valor de allocation_price_initial como número flotante
          const initialPrice = parseFloat(initialPriceElement.textContent.trim().replace(',', '.'));
          // Calcular el nuevo precio manteniendo dos decimales
          const newPrice = (initialPrice * qtyTotal).toFixed(2);
          // Asignar el nuevo precio calculado
          priceElement.textContent = newPrice+'€';
        });
      }

      renderPrice() {
        const leftPrice = this.selectedVariants.left?.price
        const leftComparePrice = this.selectedVariants.left?.compare_price
        const leftQty = leftPrice ? parseInt([...this.qtyInputs].find(input => input.dataset.eye == 'left').value) : 0
        const rightPrice = this.selectedVariants.right?.price
        const rightComparePrice = this.selectedVariants.right?.compare_price
        const rightQty = rightPrice ? parseInt([...this.qtyInputs].find(input => input.dataset.eye == 'right').value) : 0

        if (leftPrice || rightPrice) {
          let totalPrice = 0
          if (leftPrice) totalPrice += parseFloat(leftPrice) * leftQty
          if (rightPrice) totalPrice += parseFloat(rightPrice) * rightQty

          let totalDto = 0
          if (leftComparePrice) totalDto += parseFloat(leftComparePrice) * leftQty
          if (rightComparePrice) totalDto += parseFloat(rightComparePrice) * rightQty

          const prices = `
            <div class="price__sale">
              <span class="price-item price-item--sale">${this.formatPrice(totalPrice)}</span>
              ${totalDto > 0 ? `<span class="price-item price-item--regular">${this.formatPrice(totalDto)}</span>` : ''}
              <span class="price__eye">
                ${leftPrice > 0 || rightPrice > 0 ? `<span>${this.translations.price_box} ${this.translations.price_qty}
                  <span class="price__eye--sale">${this.formatPrice(leftPrice > 0 ? leftPrice : rightPrice)}</span> 
                  ${leftComparePrice > 0 || rightComparePrice > 0 ? `<span class="price__eye--regular">${this.formatPrice(leftComparePrice > 0 ? leftComparePrice : rightComparePrice)}</span> 
                  <span class="price__eye--qty">x${leftQty + rightQty}</span>` : ''}
                </span>` : ''}
              </span>
              <div class="price__discount">${this.translations.price_discount} -${this.formatPrice(totalDto - totalPrice)}</div>
            </div>
          `

          const qtyTotal = leftQty + rightQty; // Ajusta este valor según sea necesario          
          this.updateAllocationPrice('allocation_price', 'allocation_price_initial', qtyTotal);
          this.updateAllocationPrice('allocation_compared_at_price', 'allocation_compared_at_price_initial', qtyTotal);

          this.priceContainer.innerHTML = prices
          this.priceContainer.classList.remove('hidden')
        } else {
          this.priceContainer.classList.add('hidden')
        }
      }

      updateTotalQty() {
        const selectedEyes = [...this.eyes].filter(eye => eye.checked).map(eye => eye.dataset.eye)
        let total_qty = 0
        this.qtyInputs.forEach(input => {
          if (selectedEyes.includes(input.dataset.eye)) {
            total_qty += input.value * input.dataset.qty
          }
        })

        this.qtyTotal.querySelector('span').innerHTML = total_qty
        this.qtyTotal.classList.toggle('hidden', !selectedEyes.length)
      }

      updateAddToCart() {
        const leftVariant = this.selectedVariants.left
        const rightVariant = this.selectedVariants.right

        this.form.querySelectorAll('input').forEach(input => {
          input.remove()
        })

        if (leftVariant || rightVariant) {
          if (leftVariant) {
            let qty = [...this.qtyInputs].find(input => input.dataset.eye == 'left').value
            this.form.innerHTML = `<input type="hidden" name="products[]" value="${leftVariant.variant_id}|${qty}" />` + this.form.innerHTML
          }

          if (rightVariant) {
            let qty = [...this.qtyInputs].find(input => input.dataset.eye == 'right').value
            this.form.innerHTML = `<input type="hidden" name="products[]" value="${rightVariant.variant_id}|${qty}" />` + this.form.innerHTML
          }

          this.form.classList.remove('hidden')
        } else {
          this.form.classList.add('hidden')
        }
      }

      updateQty(event) {
        const button = event.currentTarget
        const qty = [...this.qtyInputs].find(input => input.dataset.eye == button.dataset.eye)
        if (button.name == 'plus') {
          qty.value++
        } else if (button.name == 'minus' && qty.value > 1) {
          qty.value--
        }

        this.renderVariantsContent()
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove('hidden');
        } else {
          this.errorMessageWrapper.classList.add('hidden');
        }
      }

      onSubmit(event) {
        event.preventDefault()

        this.form.querySelector('.lentillas__submit').setAttribute('aria-disabled', true)
        this.form.querySelector('.lentillas__submit').classList.add('loading')
        this.form.querySelector('.loading__spinner').classList.remove('hidden')
        const selectedSellingPlanInput = document.querySelector('.selected-selling-plan-id');

        let selectedSellingPlanId = selectedSellingPlanInput ? selectedSellingPlanInput.value : null;
        selectedSellingPlanId = selectedSellingPlanId && !isNaN(selectedSellingPlanId) ? parseInt(selectedSellingPlanId, 10) : null;
        
        var formData = new FormData(this.form)
        var items = []

        formData.forEach(value => {
          if (!value.includes('|')) return; // Ignorar valores inesperados

          const values = value.split('|')
          const item = {
            id: values[0],
            quantity: values[1]
          };

          //Solo agregar el selling_plan si es válido
          if (selectedSellingPlanId !== null) {
            item.selling_plan = selectedSellingPlanId;
          }

          items.push(item);
        })

        formData = {
          items,
          sections: 'cart-icon-bubble,cart-drawer,cart-notification-product'
        }

        const route = window.Shopify.routes.root ?
          window.Shopify.routes.root + 'cart/add.js' :
          window.Shopify.routes.cart_url + '/add.js'

        fetch(route, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(response =>{ 
            console.log(response)
            if (!response.ok) {
              return response.json().then(errorData => {
                this.handleErrorMessage(errorData.message);
                throw new Error(errorData.message);
              });
            }
            return response.json()
          })
          .then(data => {
            const itemsKeys = data.items.map(item => item.key)
            this.renderSections(data.sections, itemsKeys)
            document.getElementById('cart-drawer').classList.remove('is-empty')
            this.cartNotification.open()
            this.form.querySelector('.lentillas__submit').removeAttribute('aria-disabled')
          })
          .catch((error) => {
            console.error('Error:', error)
          })
          .finally(() => {
            this.form.querySelector('.lentillas__submit').classList.remove('loading')
            this.form.querySelector('.loading__spinner').classList.add('hidden')
          })
      }

      renderSections(sections, itemsKeys) {
        for (let sectionId in sections) {
          let section = document.getElementById(sectionId)
          let sectionHtml = sections[sectionId]
          if (section && sectionHtml) {
            if (sectionId == 'cart-drawer') {
              const tempElement = document.createElement('div')
              tempElement.innerHTML = sectionHtml

              document.getElementById('CartDrawer-Header').innerHTML = tempElement.querySelector('#CartDrawer-Header').innerHTML
              document.getElementById('CartDrawer-Contents').innerHTML = tempElement.querySelector('#CartDrawer-Contents').innerHTML
              document.getElementById('CartDrawer-Footer').innerHTML = tempElement.querySelector('#CartDrawer-Footer').innerHTML
            } else {
              section.innerHTML = sectionHtml

              if (sectionId == 'cart-notification-product') {
                document.querySelectorAll('[id^="cart-notification-product-"]').forEach(item => {
                  if (!itemsKeys.includes(item.dataset.key)) {
                    item.remove()
                  }
                })
              }
            }
          }
        }
      }

      formatPrice(amount) {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency
        }).format(amount)
      }
    }
  )
}

if (!customElements.get('select-lentillas')) {
  customElements.define(
    'select-lentillas',
    class SelectLentillas extends HTMLElement {
      constructor() {
        super()
        this.select = this.querySelector('.lentillas-select')
        this.items = null

        this.openEvent = this.openEvent.bind(this)
        this.closeEvent = this.closeEvent.bind(this)
        this.selectOption = this.selectOption.bind(this)

        this.generateDropdown()

        this.addEventListener('click', this.openEvent)
        document.addEventListener('click', this.closeEvent)
      }

      openEvent() {
        if (!this.select.disabled) {
          this.classList.add('open')
        }
      }

      closeEvent(event, force = false) {
        if (!this.contains(event.target) || force) {
          this.classList.remove('open')
        }
      }

      generateDropdown() {
        if (!this.select.classList.contains('readonly')) {
          const optgroups = this.select.querySelectorAll('optgroup')
          const submenus = optgroups.length ? [...optgroups].map(group => this.generateSubmenu(group.querySelectorAll('option'))) : [this.generateSubmenu(this.select.querySelectorAll('option'))]
          const menu = document.createElement('div')
          menu.classList.add('lentillas-select__menu')
          menu.innerHTML = submenus.join('')
          this.appendChild(menu)

          this.items = menu.querySelectorAll('.lentillas-select__item')
          this.items.forEach(item => {
            item.addEventListener('click', this.selectOption)
          })
        }
      }

      generateSubmenu(options) {
        return `<div class="lentillas-select__column">${[...options].map(option => this.generateItem(option)).join('')}</div>`
      }

      generateItem(option) {
        const selected = option.value == this.select.value ? 'selected' : ''
        return `<div class="lentillas-select__item ${selected}" data-value="${option.value}">${option.text}</div>`
      }

      selectOption(event) {
        event.stopPropagation()
        this.items.forEach(item => {
          item.classList.remove('selected')
        })

        const item = event.target
        this.select.value = item.dataset.value
        item.classList.add('selected')
        this.select.dispatchEvent(new Event('change', { bubbles: true }))
        this.closeEvent(true)
      }
    }
  )
}